import React from 'react'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import { useDispatch } from "react-redux";
import { closeTooltipDialog } from "../state/tooltips/actions";
import { getLastEventId } from '../selector/selectors';
import { connect } from 'react-redux';
import EditorComponent from './EditorComponent';
import { FormHelperText } from '@mui/material';

const ToolTipModal = ({
  open,
  value,
  setTooltipData,
  handleFormData,
  lastEventId,
  content,
  setContent
}) => {
    
  const dispatch = useDispatch();
  const changeHandler = (e) => {
      setTooltipData((prevState) =>
      ({...prevState, [e.target.name]: e.target.value }));
      setTooltipData((prevState) =>
      ({...prevState, event_id: lastEventId }));
  };

  const handleClose = (event, reason) => {
    setTooltipData({
      event_id : '',
      event_name:'',
    });
    dispatch(closeTooltipDialog());
  };
  return (
    <Dialog fullWidth maxWidth="sm" open={open} >
      <DialogTitle>New Event Tooltip</DialogTitle>
        <DialogContent dividers> 
          <InputLabel id="file-select-label">Event ID</InputLabel>
          <TextField  
              disabled
              margin="dense"
              id="eventId"
              fullWidth
              name="event_id"
              value={ lastEventId}
          />
          <InputLabel id="file-select-label">Description</InputLabel>
          <TextField  
              margin="dense"
              id="eventName"
              fullWidth
              name="event_name"
              value={value.event_name}
              onChange={changeHandler}
              //error={value.event_name === ""}
              //helperText={value.event_name === "" ? "Required Field!" : " "}
          />
          { value.event_name === "" ? <FormHelperText sx={{color:'#d32f2f'}} id="component-error-text">Required Field!</FormHelperText> : <></> }
          <InputLabel id="file-select-label">Description Content</InputLabel>
          <EditorComponent setContent={setContent}  isPopup={true}  event_id={lastEventId} />
          { content === "" ? <FormHelperText sx={{color:'#d32f2f'}} id="component-error-text">Required Field!</FormHelperText> : <></> }
      </DialogContent>
      <DialogActions>
        <Button  
          variant="contained"
          size="medium"
          color="primary" 
          onClick={handleFormData} >Submit</Button>
        <Button  
          variant="contained"
          size="medium"
          color="error" 
          onClick={handleClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = (state) => ({
  lastEventId:getLastEventId(state),
  //imageUploadResult:uploadImageResult(state),
});

// const mapDispatchToProps = (dispatch) => ({
//   uploadTooltipImages: (data)  => dispatch(uploadTooltipImages(data)),
// });

export default connect(mapStateToProps)(ToolTipModal);